import { ITheme } from "types/theme.types";

// Theme de l instance (un atelier par conteneur). Charge une seule fois au
// demarrage depuis /theme.json, avant le premier rendu (voir index.tsx).
// Les valeurs par defaut reproduisent l application actuelle (France) : un
// fichier absent ou invalide ne change rien et laisse la garde tenant
// desactivee (tenantId vide).
export const DEFAULT_THEME: ITheme = {
  name: "Galoche & Patin DEFAULT",
  tenantId: "",
  appTitle: "G&P Management",
  badge: "",
  logoUrl: "",
  faviconUrl: "",
  colors: {
    accent: "#c5a37b",
    accentHover: "#c28642",
    accentShade: "#f0ddc8",
    accentShadeTransparent: "#f0ddc844",
    barBackground: "#fafafa",
    listBackground: "#fbf7f2",
  },
  phone: { defaultCountry: "fr" },
  address: { countryCode: "FR", country: "France" },
  ticketPrefix: "1-1-",
};

const THEME_URL = `${process.env.PUBLIC_URL}/theme.json`;

let currentTheme: ITheme = DEFAULT_THEME;

export function getTheme(): ITheme {
  return currentTheme;
}

// Un fichier partiel reste valide : chaque section est completee par les
// valeurs par defaut.
export function mergeTheme(data: any): ITheme {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return DEFAULT_THEME;
  }
  return {
    ...DEFAULT_THEME,
    ...data,
    colors: { ...DEFAULT_THEME.colors, ...data.colors },
    phone: { ...DEFAULT_THEME.phone, ...data.phone },
    address: { ...DEFAULT_THEME.address, ...data.address },
  };
}

export async function loadTheme(): Promise<ITheme> {
  try {
    const response = await fetch(THEME_URL, { cache: "no-store" });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    // Fichier absent : nginx renvoie index.html (try_files), le parse JSON
    // echoue et on garde les valeurs par defaut.
    currentTheme = mergeTheme(await response.json());
  } catch (error) {
    console.error("[THEME] theme.json illisible, theme par defaut", error);
    currentTheme = DEFAULT_THEME;
  }
  applyTheme(currentTheme);
  return currentTheme;
}

// Les couleurs passent par des variables CSS : styles/variables.scss lit
// var(--brand-accent, ...) etc., ce qui suffit pour tous les modules scss.
export function applyTheme(theme: ITheme) {
  const style = document.documentElement.style;
  style.setProperty("--brand-accent", theme.colors.accent);
  style.setProperty("--hover-accent", theme.colors.accentHover);
  style.setProperty("--shade-accent", theme.colors.accentShade);
  style.setProperty(
    "--shade-accent-transparency",
    theme.colors.accentShadeTransparent,
  );
  style.setProperty("--bar-background", theme.colors.barBackground);
  style.setProperty("--shade-secondary", theme.colors.listBackground);
  document.title = theme.appTitle;
  if (theme.faviconUrl) {
    const favicon = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (favicon) {
      favicon.href = theme.faviconUrl;
    }
  }
}
